<main class="content blank-page">
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-10 col-xl-8 offset-lg-1 offset-xl-2">
        <p></p>
      </div>
    </div>
  </div>
</main>
